import { create } from 'zustand';

export const useUserStore = create(set => ({
  user: {},
  setUser: newUser => set(state => ({ user: newUser })),
  removeUser: () => set({ user: null }),
}));
